import React from "react";
import "../styles/room.scss"
import SvgSofa from "./room/Sofa";
import SvgEtagereMurale from "./room/EtagereMurale";
import SvgEtagere from "./room/Etagere";
import SvgLamp from "./room/Lamp";
import SvgBed from "./room/Bed";
import SvgCubes from "./room/Cubes";



function RoomComponent() {
    return (
        <section id="room" className="section section-room">


            <SvgSofa/>
            <SvgEtagereMurale/>
            <SvgEtagere/>
            <SvgLamp/>
            <SvgBed/>
            <SvgCubes/>
        </section>
    );
}

export default RoomComponent;




